//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.TypeMappingBuilderList.js";
import "../no/ObjectList.js";
let d=[[[1,"List",0,"AME.TypeMappingBuilderList",0]],[[[],"CreateTypeMapping",{R_:{mappingBuilder:"AME.TypeMappingBuilder"}},0,0],[["mappingBuilder"],"DeleteTypeMapping",{},1,0],[["adPath","nbBuilders"],"LoadAd",{R_:{builders:"AME.TypeMappingBuilder[]"}},1,0],[["nbBuilders"],"LoadAllLdTypes",{R_:{builders:"AME.TypeMappingBuilder[]"}},0,0]],[]];
SPLM.AME.TypeMappingListBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.TypeMappingListBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;